export default __webpack_public_path__ + "static/Photo Covid-2458af9fbdfcf1d70f77711c427c928f.jpg";